import { GameProposal, Player } from '../types';

export const validatePlayerCategory = (game: GameProposal, player: Player): { isValid: boolean; message: string } => {
  if (player.isTemporary) {
    return { isValid: true, message: '' };
  }

  // Validate gender compatibility first
  if (game.gender && game.gender !== 'mixed') {
    if (!player.gender) {
      return {
        isValid: false,
        message: 'Para participar deste jogo, você precisa definir seu gênero no seu perfil.'
      };
    }

    if (player.gender !== game.gender) {
      const genderLabel = game.gender === 'male' ? 'masculino' : 'feminino';
      return {
        isValid: false,
        message: `Este jogo é apenas para jogadores do gênero ${genderLabel}.`
      };
    }
  }

  if (game.sport === 'padel') {
    if (!player.padel_category) {
      return {
        isValid: false,
        message: 'Para participar deste jogo, você precisa definir sua categoria de Padel no seu perfil.'
      };
    }

    const playerCategory = String(player.padel_category);
    const allowedCategories = Array.isArray(game.requiredCategories) 
      ? game.requiredCategories 
      : game.requiredCategories?.padel || [];

    if (allowedCategories.length > 0 && !allowedCategories.includes(playerCategory)) {
      return {
        isValid: false,
        message: `Este jogo é apenas para jogadores das categorias: ${allowedCategories.join(', ')}`
      };
    }
  }

  // Fix the sport check for Beach Tennis
  if (game.sport === 'beach-tennis') {
    if (!player.beach_tennis_category) {
      return {
        isValid: false,
        message: 'Para participar deste jogo, você precisa definir sua categoria de Beach Tennis no seu perfil.'
      };
    }

    const playerCategory = String(player.beach_tennis_category);
    const allowedCategories = Array.isArray(game.requiredCategories)
      ? game.requiredCategories
      : game.requiredCategories?.beachTennis || [];

    if (allowedCategories.length > 0 && !allowedCategories.includes(playerCategory)) {
      return {
        isValid: false,
        message: `Este jogo é apenas para jogadores das categorias: ${allowedCategories.join(', ')}`
      };
    }
  }

  return { isValid: true, message: '' };
};